<template>
  <div
    class="container-wrapper"
    v-if="page.name"
    :style="
      'background-image: url(' + getBrandThemeURL('estimate/list/header_background.png') + ')'
    "
  >
    <div class="container">
      <div class="page-title">{{ page.name }}</div>
      <div class="estimate-list">
        <div
          class="estimate-list-item"
          v-for="(item, index) in page.paper_list"
          :key="index"
          @click="clickItem(item)"
        >
          <!-- 普通估分 -->
          <template v-if="item.type === 1">
            <div class="item-content">
              <p class="name">{{ item.name }}</p>
              <p class="text">{{ item.start_time }} ~ {{ item.end_time }}</p>
            </div>
            <div class="item-footer">
              <p class="button-text" :class="{ 'text-color-main': item.button_text === 2 }">
                {{ buttonText(item.button_text) }}
              </p>
            </div>
          </template>
          <!-- 资讯估分 -->
          <template v-else-if="item.type === 2">
            <div class="item-content">
              <p class="name">{{ item.name }}</p>
              <p class="text">{{ item.start_time }}</p>
            </div>
            <div class="item-footer">
              <p
                class="button-text"
                :class="{ 'text-color-main': item.button_text === 2 && item.news_url }"
              >
                {{ item.button_text === 2 && item.news_url ? '查看' : '未开始' }}
              </p>
            </div>
          </template>
        </div>
      </div>
      <div class="exam-explain">
        <p class="title">{{ page.intro_name }}</p>
        <p class="text">{{ page.intro }}</p>
      </div>
    </div>
    <FooterOpenApp
      ref="footer_open_app"
      :name="getCurrentBrand.name"
      :logoImage="getCurrentBrand.imageLogoURL"
      text="参与考试估分"
      :schemaUnitKey="schemaUnitKey"
      buttonText="打开"
    />
  </div>
</template>
<script>
import FooterOpenApp from '@/components/FooterOpenApp.vue'
import { getEstimateListApi } from '@/api/estimate'
export default {
  components: { FooterOpenApp },
  data() {
    return {
      schemaUnitKey: 'EstimateScoreDetail',
      page: {},
    }
  },
  computed: {
    buttonText: function () {
      return function (status) {
        let button_text = ''
        switch (status) {
          case 1:
            button_text = '未开始'
            break
          case 2:
            button_text = '开始估分'
            break
          case 5:
            button_text = '已下架'
            break
          default:
            break
        }
        return button_text
      }
    },
  },
  mounted() {
    this.getEstimateList()
  },
  methods: {
    // 打开app
    openApp() {
      this.$refs.footer_open_app.openApp()
    },
    getEstimateList() {
      let params = this.routeFixedParam()
      params.id = this.$route.query.id
      getEstimateListApi(params).then((res) => {
        this.page = res?.data || {}

        // 设置分享标题
        this.$util.setShare({
          title: this.page.name,
          desc: `${this.getCurrentBrand.name}APP，邀你一起估分对答案！`,
          link: window.location.href,
          imgUrl:
            'https://training-1253756937.cos.ap-chengdu.myqcloud.com/commonImage/Admin/estimate_item/image/2024-3-15/44365645878.png' ||
            '',
        })
      })
    },
    clickItem(item) {
      // 普通估分
      if (item.type === 1) {
        this.openApp()
        return
      }

      // 资讯估分
      if (item.type === 2 && item.news_url) {
        this.$util.windowLocationHref(item.news_url)
        return
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.container-wrapper {
  padding-bottom: 1.7rem;
  min-height: 100vh;
  background: #f7f8fa;
  box-sizing: border-box;
  background-size: 100%;
  background-position: top;
  background-repeat: no-repeat;

  .container {
    padding-left: 0.43rem;
    padding-right: 0.43rem;
  }
}

.page-title {
  font-size: 0.64rem;
  font-weight: bold;
  line-height: 0.85rem;
  color: #ffffff;
  padding-top: 1.15rem;
  padding-bottom: 0.83rem;
  text-align: center;
}

.estimate-list {
  background-color: #fff;
  border-radius: 0.21rem;
  padding-left: 0.43rem;
  padding-right: 0.43rem;
  margin-bottom: 0.64rem;

  &-item {
    display: flex;
    align-items: center;
    padding: 0.43rem 0;

    &:nth-child(n + 2) {
      border-top: 1px solid #ebecf0;
    }

    .item-content {
      width: 5.87rem;

      .name {
        font-size: 0.4rem;
        font-weight: 500;
        line-height: 0.59rem;
        color: #3c3d42;
        margin-bottom: 0.21rem;
      }

      .text {
        font-size: 0.32rem;
        font-weight: 400;
        line-height: 0.48rem;
        color: #919499;
      }
    }

    .item-footer {
      flex: 1;
      text-align: right;

      .button-text {
        font-size: 0.32rem;
        line-height: 0.48rem;
        color: #c2c5cc;
        text-align: right;
      }
    }
  }
}

.exam-explain {
  .title {
    font-size: 0.37rem;
    font-weight: 500;
    line-height: 0.53rem;
    color: #3c3d42;
    margin-bottom: 0.21rem;
  }

  .text {
    font-size: 0.32rem;
    font-weight: 400;
    line-height: 0.53rem;
    color: #919499;
    opacity: 0.7;
  }
}
</style>
